import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.colors.white,
    overflow: 'auto',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
    },
  },
  content: {
    margin: [0, theme.spacing(4)],
    padding: [theme.spacing(4), 0, 0],
    position: 'relative',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      height: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
      padding: [theme.spacing(7), 20, 138],
    },
  },
  header: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(8),
      fontSize: 32,
    },
  },
  forms: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
    },
  },
  form: {
    [theme.breakpoints.up('mobile')]: {
      marginRight: 48,
      width: '50%',
      '&:last-child': {
        marginRight: 0,
        marginLeft: 48,
      },
    },
  },
  loaderContainer: {
    position: 'absolute',
    top: 0,
    background: theme.palette.colors.white,
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/useStyles.js